import React, { useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import { Delete, Post } from "../../config/api";
import { UPLOADS_URL } from "../../config/constants/api";
import moment from "moment";
import { FaThumbsUp } from "react-icons/fa";

export default function Comment({
  Comment: { text, createdAt, user, _id, likes = [] },
  postId,
  refetch,
}) {
  // console.log("post Id from comment =>", postId);
  const loggedUserId = useSelector((state) => state.user.userData._id);
  const [isHide, setIsHide] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const [loader, setLoader] = useState(false);
  const [localLikes, setLocalLikes] = useState(likes);
  const hasLiked = localLikes.includes(loggedUserId);

  async function deleteComment() {
    setLoader(true);
    setIsHide(!isHide);
    try {
      const response = await Delete(
        `/community/${postId}/comment/` + _id,
        token,
        {}
      );
      if (response?.status === true) {
        refetch();
        swal("Success", "Comment deleted successfully", "success");
        setLoader(false);
      } else {
        swal(
          "Oops!",
          response?.data?.message || response?.response?.data?.message,
          "error"
        );
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      swal("Error", "An error occurred while deleting the comment ");
      console.log(error);
    }
  }

  async function likeComment() {
    setLoader(true);
    try {
      const response = await Post(
        `/community/${postId}/comment/${_id}/like`,
        {},
        token
      );
      console.log("response from like comment =>", response);

      if (response?.data?.status === true) {
        // Toggle like locally for instant UI feedback
        if (hasLiked) {
          setLocalLikes(localLikes.filter((id) => id !== loggedUserId));
        } else {
          setLocalLikes([...localLikes, loggedUserId]);
        }
        refetch(); // optionally re-fetch if backend updates are needed
      }
    } catch (error) {
      console.error("Like error =>", error);
    } finally {
      setLoader(false);
    }
  }

  const isOwner = loggedUserId === user?._id;

  return (
    <article className="community-post-comment">
      {loader ? (
        <div className="community-post-comment-loading" aria-busy="true">
          <span className="community-post-comment-loading-spinner" aria-hidden="true" />
          <span className="community-post-comment-loading-text">Updating...</span>
        </div>
      ) : (
        <>
          <div className="community-post-comment-inner">
            <div className="community-post-comment-header">
              <img
                src={
                  user?.image
                    ? UPLOADS_URL + "/" + user.image
                    : "https://www.pngkey.com/png/full/114-1149878_setting-user-avatar-in-specific-size-without-breaking.png"
                }
                className="community-post-comment-avatar"
                alt=""
              />
              <div className="community-post-comment-meta">
                <p className="community-post-comment-author">
                  {user?.firstName && `${user.firstName} ${user.lastName || ""}`}
                </p>
                <time className="community-post-comment-date" dateTime={createdAt}>
                  {moment(createdAt).format("MMMM Do YYYY, h:mm:ss a")}
                </time>
              </div>
            </div>

            <p className="community-post-comment-text">{text}</p>

            <div className="community-post-comment-actions">
              <button
                type="button"
                onClick={likeComment}
                disabled={loader}
                className={`community-post-comment-like${hasLiked ? " community-post-comment-like--active" : ""}`}
              >
                <FaThumbsUp className="community-post-comment-like-icon" aria-hidden="true" />
                <span>{hasLiked ? "Liked" : "Like"}</span>
              </button>
              {localLikes.length > 0 ? (
                <span className="community-post-comment-like-count">{localLikes.length}</span>
              ) : null}
            </div>
          </div>

          {isOwner ? (
            <div className="community-post-comment-menu">
              <button
                type="button"
                className="community-post-comment-menu-trigger"
                aria-expanded={!isHide}
                aria-label="Comment options"
                onClick={() => setIsHide(!isHide)}
              >
                <PiDotsThreeOutlineFill size={22} aria-hidden="true" />
              </button>

              {!isHide && (
                <div className="community-post-comment-menu-dropdown" role="menu">
                  <button
                    type="button"
                    role="menuitem"
                    className="community-post-comment-menu-delete"
                    onClick={() => {
                      swal({
                        title: "Are you sure?",
                        text: "Once deleted, you will not be able to recover this!",
                        icon: "warning",
                        buttons: {
                          cancel: "Cancel",
                          confirm: "Yes, delete it!",
                        },
                        dangerMode: true,
                      }).then((willDelete) => {
                        if (willDelete) deleteComment();
                      });
                    }}
                  >
                    Delete comment
                  </button>
                </div>
              )}
            </div>
          ) : null}
        </>
      )}
    </article>
  );
}
